import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgentSettlementRoutes = defineRoute({
    record: {
        route: {
            path: "/agent-settlement",
            component: () => loadView(import("./AgentSettlementTable.vue")),
        },
    },
    create: {
        route: {
            path: "/agent-settlement/create/:associateUserId",
            component: () => loadView(import("./AgentSettlementCreate.vue")),
        },
        build(associateUserId: string) {
            return `/agent-settlement/create/${associateUserId}`;
        },
    },
});
